export var LabelVariants;
(function (LabelVariants) {
    LabelVariants["neutral"] = "neutral";
    LabelVariants["positive"] = "positive";
    LabelVariants["negative"] = "negative";
    LabelVariants["primary"] = "primary";
    LabelVariants["secondary"] = "secondary";
})(LabelVariants || (LabelVariants = {}));
export var LabelWeights;
(function (LabelWeights) {
    LabelWeights["regular"] = "regular";
    LabelWeights["bold"] = "bold";
})(LabelWeights || (LabelWeights = {}));
export var LabelSizes;
(function (LabelSizes) {
    LabelSizes["xsmall"] = "xsmall";
    LabelSizes["small"] = "small";
    LabelSizes["medium"] = "medium";
    LabelSizes["large"] = "large";
    LabelSizes["xlarge"] = "xlarge";
})(LabelSizes || (LabelSizes = {}));
//# sourceMappingURL=constants.js.map